import VerifyPhoneForm from './VerifyPhoneForm';
export default VerifyPhoneForm;